var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',_vm._g(_vm._b({attrs:{"max-width":"300","offset-y":_vm.offsetY},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,{"on":on})]}}],null,true)},'v-menu',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }